import { render } from "./VoucherCategories.vue?vue&type=template&id=1560063a&scoped=true"
import script from "./VoucherCategories.vue?vue&type=script&lang=js"
export * from "./VoucherCategories.vue?vue&type=script&lang=js"

import "./VoucherCategories.vue?vue&type=style&index=0&id=1560063a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1560063a"]])

export default __exports__